<template>
  <router-link class="tile tile--lender link__none" :to="`/loan-officers/${lender._id}`">
    <div class="lender--headshot">
      <img v-if="lender.headshot" :src="lender.headshot" :alt="`${lender.name.first}'s headshot`" />
      <span v-else class="default__avatar flex__center">{{ defaultAvatar }}</span>
    </div>
    <p class="flex__center">
      <span class="text__overflow text__bold">{{ lender.display_name }}</span>
    </p>
    <p class="flex__between">
      <span class="text__bold mr-10">Email</span>
      <span class="text__overflow">{{ lender.email }}</span>
    </p>
    <p class="flex__between">
      <span class="text__bold">NMLS</span>
      <span class="text__overflow">{{ lender.nmls }}</span>
    </p>
    <p class="flex__between">
      <span class="text__bold">Live</span>
      <span>{{ lender.status.live ? "Yes": "No" }}</span>
    </p>
    <button class="btn" @click="startSetActive(lender._id)">See Lender</button>
  </router-link>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["lender"],
  computed: {
    defaultAvatar() {
      const names = this.lender.display_name.split(" ");
      const first = names[0].split("")[0].toUpperCase();
      const last = names[names.length - 1].split("")[0].toUpperCase();
      return `${first} ${last}`;
    }
  },
  methods: {
    ...mapActions({
      startSetActive: "loanOfficers/startSetActive"
    })
  }
};
</script>